var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoldIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "qih97blgwa",
    x1: 1.226,
    y1: 0.5,
    x2: 0,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f3d163"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dfa440"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "m3.2 16 .641-1.84a.767.767 0 0 1 .72-.56H6.4l.56-1.679A4.813 4.813 0 0 1 3.2 7.2v-.081a3.627 3.627 0 0 1-3.2-3.6V1.6A.755.755 0 0 1 .8.8h2.4V0h9.6v.8h2.4a.755.755 0 0 1 .8.8v1.92a3.627 3.627 0 0 1-3.2 3.6v.08a4.813 4.813 0 0 1-3.76 4.72l.56 1.68h1.839a.767.767 0 0 1 .72.56L12.8 16z",
    style: {
      fill: "url(#qih97blgwa)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldIcon);
export default __webpack_public_path__ + "static/media/gold-icon.19bebb49402bd691cccb36d7c2f68f61.svg";
export { ForwardRef as ReactComponent };